module.exports = {
    DutchCustomsNewsFeed: 'Dutch Customs News Feed',
    NewsOverview: 'News Overview',
    OpenInTaricSupport: 'Open in Taric Support'
};